import type { OutboxItemState } from '@Domain/Ports/Outbox/OutboxPort';

/** A `draft` with no capture running in any tab of this device is a recording that was interrupted. */
const isInterruptedRecording = (state: OutboxItemState, isCaptureInProgress: boolean): boolean =>
	state === 'draft' && !isCaptureInProgress;

export default isInterruptedRecording;
